export const locations = {
  root: () => '/',
  signIn: () => '/sign-in',
  settings: () => '/settings',
}
